import InsurancePage from "./InsurancePage";

const ACCIDENTAL_BENEFITS = [
  { rank: "Motivator", value: "1 Lakh (2 Adult)" },
  { rank: "Senior Motivator", value: "2 Lakh (2 Adult)" },
  { rank: "Co.ordinator", value: "3 Lakh (2 Adult) + 1 Lakh (2 Child)" },
  { rank: "Senior Co.ordinator", value: "4 Lakh (2 Adult) + 1 Lakh (2 Child)" },
  { rank: "Manager", value: "5 Lakh (2 Adult) + 1 Lakh (2 Child)" },
  { rank: "Director", value: "10 Lakh (2 Adult) + 1 Lakh (2 Child)" },
];

export default function AccidentalInsurance() {
  return (
    <InsurancePage
      testId="accidental-insurance-page"
      title="Accidental Insurance"
      themeColor={{ header: "#1e3a8a", darker: "#1e40af", tint: "#eef2ff" }}
      benefits={ACCIDENTAL_BENEFITS}
    />
  );
}
